import { FormField } from 'ui/formField';
import { RadioGroup } from 'ui/radioGroup/radioGroup';
import { WEBHOOK_STATUS_OPTIONS } from '../constants';
import { SystemWebhookFormState } from '../types';

export const StatusFormField = ({
  webhook,
  updateWebhook,
}: {
  webhook: SystemWebhookFormState;
  updateWebhook: (field: string, value: string) => void;
}) => {
  return (
    <FormField data-test="form-field-webhookStatus" inputId="webhookStatus" labelText="Status">
      <RadioGroup
        name="webhookStatus"
        options={WEBHOOK_STATUS_OPTIONS.map((option) => ({
          ...option,
          id: `webhookStatus-${option.value}`,
          name: option.value,
        }))}
        value={webhook?.enabled}
        onSelect={(val: string) => {
          updateWebhook('enabled', val);
        }}
      />
    </FormField>
  );
};
